import React, { useState } from "react";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import api from "@/lib/api";
import { publicLink } from "@/lib/landerDomain";

const BTN = "border-2 border-black bg-white px-2 py-1 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 transition-colors duration-100 hover:bg-black hover:text-white disabled:opacity-40";
const err = (e) => e?.response?.data?.detail || "Couldn't send the test lead";

// Optional: one marked test lead through each live page, then a link to the thank-you page it reached.
export function DomainTestLeads({ b }) {
  const pages = b.pages.filter((p) => p.live);
  const [sent, setSent] = useState(null);
  const [busy, setBusy] = useState(false);
  const id = `domain-check-buyer-${b.code}-tests`;
  if (!pages.length || b.delivery.status === "fail") return null;
  const run = async () => {
    if (!window.confirm(`Send ${pages.length} TEST lead${pages.length === 1 ? "" : "s"}, one from each live page, to ${b.firm_name}'s real delivery? They're marked as tests and kept out of billing and reports.`)) return;
    setBusy(true);
    const out = {};
    for (const p of pages) {
      try {
        const body = { buyer_page_id: b.page_id, ...(p.kind === "own" ? { page_slug: p.key } : { funnel: p.key }) };
        const { data } = await api.post("/admin/global-funnels/test-lead", body);
        out[p.key] = { ok: true, path: data.thank_you_path };
      } catch (e) {
        out[p.key] = { ok: false, error: err(e) };
      }
      setSent({ ...out });
    }
    setBusy(false);
  };
  return (
    <div className="mt-2 border-t border-zinc-300 pt-2" data-testid={id}>
      <button type="button" onClick={run} disabled={busy} className={BTN} data-testid={`${id}-send`}>
        <PaperPlaneTilt size={11} weight="bold" /> {busy ? "Sending…" : "Also send a test lead through each page"}
      </button>
      {sent && (
        <ul className="mt-1 text-[11.5px]">
          {pages.filter((p) => sent[p.key]).map((p) => (
            <li key={p.key} data-testid={`${id}-${p.key}`} className={sent[p.key].ok ? "text-emerald-700" : "text-red-600"}>
              {p.title}: {sent[p.key].ok ? "test lead sent" : sent[p.key].error}
              {sent[p.key].path && <> · <a href={publicLink(sent[p.key].path)} target="_blank" rel="noopener noreferrer" className="underline">thank-you it showed</a></>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
